// extracted by mini-css-extract-plugin
module.exports = {"nearbyBuoysHeader":"NearbyBuoysHeader_nearbyBuoysHeader__BV2T2","nearbyBuoysTitle":"NearbyBuoysHeader_nearbyBuoysTitle__J_H3J"};